module.exports = __webpack_public_path__ + "img/mixed-reality.13459a5e.png";